module.exports = __webpack_public_path__ + "static/media/khanda.8a9399d3.svg";